import { render } from "./MobileNav.vue?vue&type=template&id=bff8bc0c&scoped=true"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"

import "./MobileNav.css?vue&type=style&index=0&id=bff8bc0c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff8bc0c"]])

export default __exports__